import { render, staticRenderFns } from "./expertSeminarEdit.vue?vue&type=template&id=79766b4a&"
import script from "./expertSeminarEdit.vue?vue&type=script&lang=js&"
export * from "./expertSeminarEdit.vue?vue&type=script&lang=js&"
import style0 from "./expertSeminarEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports